/* 🤖 this file was generated by svg-to-ts*/
export const icoShareFilled: {
  name: 'share-filled';
  data: string;
} = {
  name: 'share-filled',
  data: `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M18.5 2a3.5 3.5 0 11-2.478 5.972L8.928 11.79a3.516 3.516 0 01.037 1.206l6.909 3.19a3.5 3.5 0 11-.839 1.817l-6.909-3.19a3.5 3.5 0 11-.148-4.786l7.094-3.818A3.5 3.5 0 0118.5 2z" fill="#909090"/></svg>`
};
